import {request} from "@/util/request";

export function GetTreeTable(params) {
    return request({
        url: '/Tree.asmx/GetDeptTreeList',
        method: 'GET',
        params
    })
}

export function GetDeptTreeTable() {
    return request({
        url: '/DeptTree.asmx/GetDeptTreeList',
        method: 'GET'
    })
}

export function GetSmsTreeTable(params) {
    return request({
        url: '/SmsTree.asmx/GetDeptTreeList',
        method: 'GET',
        params
    })
}

export function SendWorkMsg(params) {
    return request({
        url: '/Tree.asmx/SendWorkMsg',
        method: 'GET',
        params
    })
}